/**
 * return value of blending call status
 *
 * THIS IS ONLY A TEMPORARY DIAL UP CODE WHICH WILL BE REMOVED IN
 * SIM: https://sim.amazon.com/issues/caracara-29513
 * PLEASE DO NOT USE THIS METHOD IN ANY OTHER PLACE
 * @returns
 */
export function getBlendingStatus() {
    let useBlending = false;
    try {
        useBlending = window.localStorage.getItem('useBlending') === 'true';
    }
    catch (e) {
        useBlending = false;
    }
    return useBlending;
}
/**
 * set feature flag for blending
 *
 * THIS IS ONLY A TEMPORARY DIAL UP CODE WHICH WILL BE REMOVED IN
 * SIM: https://sim.amazon.com/issues/caracara-29513
 * PLEASE DO NOT USE THIS METHOD IN ANY OTHER PLACE
 * @param useBlending
 * @returns
 */
export function setBlendingStatus(useBlending) {
    try {
        window.localStorage.setItem('useBlending', String(!!useBlending));
    }
    catch (e) {
        return false;
    }
    return true;
}
//# sourceMappingURL=UseBlending.js.map